// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/assets/images/employersSection2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.employersPageWrap .section1 {
    background: #150924;
    color: white;
}

.employersPageWrap .section1 .heading {
    color: white;
    font-size: 56px;
    line-height: 68px;
    padding: 0px;
}

.employersPageWrap .section1 .subheading {
    line-height: 34px;
}

.employersPageWrap .sec-2-btn {
    margin-bottom: 30px;
}

.employersPageWrap .sec-2-btn a {
    text-decoration: none;
    color: #141414 !important;
}
.employersPageWrap .textBlack {
    color: #242424 !important;
    -webkit-text-fill-color: #242424;
}

.employersPageWrap .sec-2-btn a:hover {
    text-decoration: none !important;
}

.Job-search-section .wrapper a {
    color: #141414 !important;
    text-decoration: none !important;
}

.Job-search-section .wrapper a:hover {
    text-decoration: none !important;
}

.employersPageWrap .primaryButton {
    background: #06efc5;
    font-size: 18px;
    font-weight: 800;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
}

.employersPageWrap .secondaryButton {
    background: none;
    color: #06efc5;
    font-size: 18px;
    font-weight: 800;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
}

.employersPageWrap .section2 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    min-height: 353px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    gap: 30px;
    background-color: #150924;
}

.employersPageWrap .section2 .heading {
    font-size: 34px;
    color: white;
    font-weight: 700;
    line-height: 47px;
    text-align: center;
    width: unset;
    padding: unset;
}

.employersPageWrap .section3 {
    background: #150924;
    color: white;
}

.employersPageWrap .section3 .tag {
    font-size: 22px;
    font-weight: 600;
    line-height: 33px;
    color: #150924;
    background: #38bbf4;
    width: fit-content;
    margin: auto;
    padding: 2px 15px;
    border-radius: 20px;
}

.employersPageWrap .accordion-button:not(.collapsed) {
    color: #150924;
    background: #38bbf4;
}

.employersPageWrap .accordion-body {
    background: #191b38;
}

.employersPageWrap .section3 .subheading {
    margin-top: 10px;
    font-size: 39px;
    font-weight: 700;
    line-height: 75px;
    text-align: center;
    margin-bottom: 87px;
}

.employersPageWrap .section4 {
    background: #150924;
    color: white;
    padding: 100px 0;
}

.employersPageWrap .section4 .heading {
    font-size: 39px;
    font-weight: 700;
    line-height: 75px;
    text-align: center;
    color: white;
    width: unset;
    padding: unset;
    margin-bottom: 65px;
}

.employersPageWrap .section4 .slider-container {
    width: 100%;
    overflow: hidden;
}

.employersPageWrap .section4 .card-wrap {
    height: 280px;
    padding: 40px 26px;
    margin-right: 40px;
    overflow: hidden;
}

.employersPageWrap .section4 .card-wrap .title {
    font-size: 54px;
    font-weight: 800;
    line-height: 33px;
    letter-spacing: -0.02em;
    text-align: left;
    margin-bottom: 25px;
    font-family: "Inter", sans-serif;
}

.employersPageWrap .section4 .card-wrap .description {
    font-size: 22px;
    font-weight: 300;
    line-height: 33px;
    letter-spacing: -0.02em;
    text-align: left;
}

.employersPageWrap .employeesAccordian .accordion-button::after {
    display: none;
}

.employersPageWrap .employeesAccordian {
    display: flex;
    gap: 22px;
    flex-direction: column;
}

.employersPageWrap .employeesAccordian .accordion-button {
    font-size: 24px;
    font-weight: 600;
    line-height: 33px;
    text-align: left;
}

.employersPageWrap .employeesAccordian .accordion-body {
    font-size: 20px;
    font-weight: 400;
    line-height: 33px;
    text-align: left;
}

.employersPageWrap .accordion-button:not(.collapsed) .iconImage {
    filter: brightness(0);
}

.employersPageWrap .accordion-button .iconImage {
    filter: brightness(100);
}

.employersPageWrap .accordianWrap {
    max-width: 523px;
    width: 39%;
    flex: 1 1;
}

@media screen and (max-width: 1420px) {
    .employersPageWrap .section4 .card-wrap .description {
        font-size: 20px;
    }
}

@media screen and (max-width: 1024px) {
    .employersPageWrap .section1 {
        gap: 50px;
    }
}

@media screen and (max-width: 768px) {
    .employersPageWrap .section1 {
        gap: 50px;
    }

    .employersPageWrap .ResponsiveWrapper {
        gap: 50px;
    }

    .employersPageWrap .section4 .slider-container {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .employersPageWrap .section4 .card-wrap {
        height: unset;
        width: 100%;
        padding: 34px 26px;
    }
    .employersPageWrap .primaryButton {
        font-size: 15px;
        width: 100%;
        line-height: normal;
    }
}

@media screen and (max-width: 480px) {
    .employersPageWrap .section1 .heading {
        font-size: 25px;
        line-height: normal;
    }

    .employersPageWrap .section1 .heading span {
        display: inline-block;
    }

    .employersPageWrap .section1 .heading br {
        display: none;
    }

    .employersPageWrap .section1 .subheading {
        font-size: 15px !important;
        line-height: 19px;
    }

    .employersPageWrap .primaryButton {
        font-size: 15px;
        width: 100%;
        line-height: normal;
    }

    .employersPageWrap .secondaryButton {
        font-size: 15px;
        margin: 0 auto;
    }

    .employersPageWrap .section2 {
        padding: 25px;
    }

    .employersPageWrap .section2 .heading {
        font-size: 25px;
        line-height: 39px;
        padding-top: 20px;
    }

    .employersPageWrap .section3 .tag {
        font-size: 12px;
    }

    .employersPageWrap .section3 .subheading {
        font-size: 25px;
        line-height: 39px;
        margin-bottom: 37px;
    }

    .employersPageWrap .accordianWrap {
        width: 100%;
        max-width: unset;
        min-width: unset;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .employersPageWrap .employeesAccordian .accordion-button {
        font-size: 20px;
        line-height: 25px;
    }

    .employersPageWrap .employeesAccordian .accordion-body {
        font-size: 12px;
        line-height: 19px;
    }

    .employersPageWrap .section4 .heading {
        font-size: 25px;
        line-height: 39px;
    }

    .employersPageWrap .section4 {
        padding: 50px 25px;
    }

    .employersPageWrap .section4 .slider-container {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .employersPageWrap .section4 .card-wrap {
        height: unset;
        width: 100%;
        padding: 34px 26px;
    }

    .employersPageWrap .section4 .card-wrap .title {
        font-size: 25px;
        line-height: normal;
        margin-bottom: 20px;
    }

    .employersPageWrap .section4 .card-wrap .description {
        font-size: 12px;
        line-height: 19px;
        margin-bottom: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/LandingPages/Employers.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,yDAA4E;IAC5E,iBAAiB;IACjB,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAO;AACX;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,WAAW;QACX,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;AACJ","sourcesContent":[".employersPageWrap .section1 {\n    background: #150924;\n    color: white;\n}\n\n.employersPageWrap .section1 .heading {\n    color: white;\n    font-size: 56px;\n    line-height: 68px;\n    padding: 0px;\n}\n\n.employersPageWrap .section1 .subheading {\n    line-height: 34px;\n}\n\n.employersPageWrap .sec-2-btn {\n    margin-bottom: 30px;\n}\n\n.employersPageWrap .sec-2-btn a {\n    text-decoration: none;\n    color: #141414 !important;\n}\n.employersPageWrap .textBlack {\n    color: #242424 !important;\n    -webkit-text-fill-color: #242424;\n}\n\n.employersPageWrap .sec-2-btn a:hover {\n    text-decoration: none !important;\n}\n\n.Job-search-section .wrapper a {\n    color: #141414 !important;\n    text-decoration: none !important;\n}\n\n.Job-search-section .wrapper a:hover {\n    text-decoration: none !important;\n}\n\n.employersPageWrap .primaryButton {\n    background: #06efc5;\n    font-size: 18px;\n    font-weight: 800;\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    justify-content: center;\n}\n\n.employersPageWrap .secondaryButton {\n    background: none;\n    color: #06efc5;\n    font-size: 18px;\n    font-weight: 800;\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    justify-content: center;\n}\n\n.employersPageWrap .section2 {\n    background-image: url(\"../../../public/assets/images/employersSection2.png\");\n    min-height: 353px;\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    gap: 30px;\n    background-color: #150924;\n}\n\n.employersPageWrap .section2 .heading {\n    font-size: 34px;\n    color: white;\n    font-weight: 700;\n    line-height: 47px;\n    text-align: center;\n    width: unset;\n    padding: unset;\n}\n\n.employersPageWrap .section3 {\n    background: #150924;\n    color: white;\n}\n\n.employersPageWrap .section3 .tag {\n    font-size: 22px;\n    font-weight: 600;\n    line-height: 33px;\n    color: #150924;\n    background: #38bbf4;\n    width: fit-content;\n    margin: auto;\n    padding: 2px 15px;\n    border-radius: 20px;\n}\n\n.employersPageWrap .accordion-button:not(.collapsed) {\n    color: #150924;\n    background: #38bbf4;\n}\n\n.employersPageWrap .accordion-body {\n    background: #191b38;\n}\n\n.employersPageWrap .section3 .subheading {\n    margin-top: 10px;\n    font-size: 39px;\n    font-weight: 700;\n    line-height: 75px;\n    text-align: center;\n    margin-bottom: 87px;\n}\n\n.employersPageWrap .section4 {\n    background: #150924;\n    color: white;\n    padding: 100px 0;\n}\n\n.employersPageWrap .section4 .heading {\n    font-size: 39px;\n    font-weight: 700;\n    line-height: 75px;\n    text-align: center;\n    color: white;\n    width: unset;\n    padding: unset;\n    margin-bottom: 65px;\n}\n\n.employersPageWrap .section4 .slider-container {\n    width: 100%;\n    overflow: hidden;\n}\n\n.employersPageWrap .section4 .card-wrap {\n    height: 280px;\n    padding: 40px 26px;\n    margin-right: 40px;\n    overflow: hidden;\n}\n\n.employersPageWrap .section4 .card-wrap .title {\n    font-size: 54px;\n    font-weight: 800;\n    line-height: 33px;\n    letter-spacing: -0.02em;\n    text-align: left;\n    margin-bottom: 25px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.employersPageWrap .section4 .card-wrap .description {\n    font-size: 22px;\n    font-weight: 300;\n    line-height: 33px;\n    letter-spacing: -0.02em;\n    text-align: left;\n}\n\n.employersPageWrap .employeesAccordian .accordion-button::after {\n    display: none;\n}\n\n.employersPageWrap .employeesAccordian {\n    display: flex;\n    gap: 22px;\n    flex-direction: column;\n}\n\n.employersPageWrap .employeesAccordian .accordion-button {\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 33px;\n    text-align: left;\n}\n\n.employersPageWrap .employeesAccordian .accordion-body {\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 33px;\n    text-align: left;\n}\n\n.employersPageWrap .accordion-button:not(.collapsed) .iconImage {\n    filter: brightness(0);\n}\n\n.employersPageWrap .accordion-button .iconImage {\n    filter: brightness(100);\n}\n\n.employersPageWrap .accordianWrap {\n    max-width: 523px;\n    width: 39%;\n    flex: 1;\n}\n\n@media screen and (max-width: 1420px) {\n    .employersPageWrap .section4 .card-wrap .description {\n        font-size: 20px;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .employersPageWrap .section1 {\n        gap: 50px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .employersPageWrap .section1 {\n        gap: 50px;\n    }\n\n    .employersPageWrap .ResponsiveWrapper {\n        gap: 50px;\n    }\n\n    .employersPageWrap .section4 .slider-container {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n    }\n\n    .employersPageWrap .section4 .card-wrap {\n        height: unset;\n        width: 100%;\n        padding: 34px 26px;\n    }\n    .employersPageWrap .primaryButton {\n        font-size: 15px;\n        width: 100%;\n        line-height: normal;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .employersPageWrap .section1 .heading {\n        font-size: 25px;\n        line-height: normal;\n    }\n\n    .employersPageWrap .section1 .heading span {\n        display: inline-block;\n    }\n\n    .employersPageWrap .section1 .heading br {\n        display: none;\n    }\n\n    .employersPageWrap .section1 .subheading {\n        font-size: 15px !important;\n        line-height: 19px;\n    }\n\n    .employersPageWrap .primaryButton {\n        font-size: 15px;\n        width: 100%;\n        line-height: normal;\n    }\n\n    .employersPageWrap .secondaryButton {\n        font-size: 15px;\n        margin: 0 auto;\n    }\n\n    .employersPageWrap .section2 {\n        padding: 25px;\n    }\n\n    .employersPageWrap .section2 .heading {\n        font-size: 25px;\n        line-height: 39px;\n        padding-top: 20px;\n    }\n\n    .employersPageWrap .section3 .tag {\n        font-size: 12px;\n    }\n\n    .employersPageWrap .section3 .subheading {\n        font-size: 25px;\n        line-height: 39px;\n        margin-bottom: 37px;\n    }\n\n    .employersPageWrap .accordianWrap {\n        width: 100%;\n        max-width: unset;\n        min-width: unset;\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n    }\n\n    .employersPageWrap .employeesAccordian .accordion-button {\n        font-size: 20px;\n        line-height: 25px;\n    }\n\n    .employersPageWrap .employeesAccordian .accordion-body {\n        font-size: 12px;\n        line-height: 19px;\n    }\n\n    .employersPageWrap .section4 .heading {\n        font-size: 25px;\n        line-height: 39px;\n    }\n\n    .employersPageWrap .section4 {\n        padding: 50px 25px;\n    }\n\n    .employersPageWrap .section4 .slider-container {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n    }\n\n    .employersPageWrap .section4 .card-wrap {\n        height: unset;\n        width: 100%;\n        padding: 34px 26px;\n    }\n\n    .employersPageWrap .section4 .card-wrap .title {\n        font-size: 25px;\n        line-height: normal;\n        margin-bottom: 20px;\n    }\n\n    .employersPageWrap .section4 .card-wrap .description {\n        font-size: 12px;\n        line-height: 19px;\n        margin-bottom: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
